<template>
  <div class="edit_main">
    <div class="fx_1">
      <Form ref="editModel" :model="editModel"  :label-width="140">
        <FormItem label="查询标题（唯一）" prop="queryTitle">
          <Input disabled class="w-250" v-model="editModel.queryTitle"></Input>
        </FormItem>
        <FormItem label="数据库类型" prop="dataBaseType">
          <Select disabled class="w-250" v-model="editModel.dataBaseType" clearable>
            <Option
              v-for="(item, index) in dataBaseTypeSelect"
              :value="item.value"
              :key="index"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="数据库连接字符串" prop="dataBaseConnection">
          <Input disabled v-model="editModel.dataBaseConnection" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>

        <FormItem label="查询语句" prop="querySql">
          <Input disabled v-model="editModel.querySql" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>

        <FormItem label="描述信息" prop="description">
          <Input disabled v-model="editModel.description" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
        </FormItem>
      </Form>
      <h3 class="mb-4">
        字段别名设置
        <span style="color:red">（注：字段别名必须和查询语句返回的字段一一对应）</span>
      </h3>
      <Form ref="additemModel" :label-width="140" inline>
        <div class="dictionaryItems-panel">
          <div v-for="(item,index) in fieldAliasArr" :key="index">
            <FormItem label="字段">
              <Input disabled class="w-180" v-model="item.key"></Input>
            </FormItem>
            <FormItem label="字段中文名">
              <Input disabled class="w-180" v-model="item.title"></Input>
            </FormItem>
          </div>
        </div>
      </Form>
    </div>
    <div class="edit_btn_group">
      <Button type="info" @click="returnBack">返 回</Button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data: function () {
    return {
      organParentName: "",
      editModel: {
        id: "",
        queryTitle: "",
        dataBaseType: "",
        dataBaseConnection: "",
        querySql: "",
        description: "",
        fieldAlias: "",
        createUser: "",
      },
      additemModel:{},
      fieldAliasArr: [],
      dataBaseTypeSelect: [],
    };
  },

  activated: function () {
    this.dataBaseTypeSelect = this.$common.getJsonData("dataBaseType");
    this.initData()
  },

  methods: {
    initData(){
      this.$api.get("customquery/getById", {id:this.$route.query.id}).then((rsp) => {
        if (rsp != false) {
          this.editModel=rsp.data
          this.fieldAliasArr = JSON.parse(this.editModel.fieldAlias);
        }
      });
    },
    returnBack: function () {
      this.$router.push({ path: "customquery" });
    },

    addItem() {
      var temp = { key: "", title: "" };
      this.fieldAliasArr.push(temp);
    },

    deleteItem(index) {
      this.fieldAliasArr.splice(index, 1);
    },

 
  },
};
</script>
<style scoped>
</style>